
<template>
    <div class="container">
<!-- <h2>Tipo de Equipos</h2>
<v-divider></v-divider> -->
        
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">ADMINISTRAR AREAS RESPONSABLES</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
            <modal-ayuda></modal-ayuda>
            <v-card-text>
                <!-- <v-btn color="green" fab small dark @click="crear">
                        <v-icon>add</v-icon>
                </v-btn> -->
            </v-card-text>
            <!-- <Tabla :ajustes="this.ajustes" @editar="editar($event)"></Tabla> -->
        </v-card>

        <tabla-paginada @cargar="cargar($event)" @editar="editar($event)" @usuarios="cargar_responsables($event)"></tabla-paginada>

    <v-dialog
      v-model="dialog"
      scrollable
      max-width="600px"
    >
      <v-card>
        <v-card-title>Usuarios Responsables</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <v-autocomplete
          
            v-model="responsables_ids"
            multiple
            dense
            chips
            deletable-chips
            item-text="name"
            item-value="id"
            :items="usuarios"
          ></v-autocomplete>

          <!-- <pre>{{responsables_ids}}</pre> -->

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="guardar_responsables"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

            <modal @peticionrealizada="cargar('')"></modal>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
import Tabla from '@/components/shared/Tabla.vue';
import Data_Table from '@/components/shared/Data_Table.vue';
import TablaPaginada from '@/components/shared/TablaPaginada.vue';
import ModalVue from '../../components/shared/Modal.vue';
import ModalAyudas from '../../components/shared/ModalAyudas.vue';

export default {
    data:()=>({
        lista:[],
        lotes:[],
        proviene_de:[],
        inputs:[
            {tipo:'texto',valor:'',label:'Area Responsable*',key:'nombre'},
            {tipo:'switch',valor:1,label:'Activo*',key:'activo'}
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:'',
            motivos_repaso:[]
        },
        columnas:[
            {nombre:'Area Responsable',align: 'center',tipo: 'texto',path: 'nombre',key:'nombre',searchable:true,busqueda:''},
            {nombre:'Activo',align:'center',tipo: 'numero',path: 'activo_texto',key:'activo',searchable:true,busqueda:''},
            {nombre:'Responsables', key:'responsables',tipo:'evento',color:'#1565C0',icono:'list',evento:'usuarios',searchable:false},
            {nombre:'Editar', key:'editar',tipo:'evento',color:'#1565C0',icono:'create',evento:'editar',searchable:false},
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true}
        ],
        dialog:false,
        responsables_ids:null,
        usuarios:[],
        item_actual:null
    }),
    created() {
        // Event.$on('peticion_realizada',()=>{
        //     this.cargarDatos()
        // })
    },
    beforeDestroy() {
        Event.$off('actualizar_tabla');
    },
    mounted() {
        this.cargar('');
        Event.$on('actualizar_tabla',()=>{
            this.cargar('');
        });
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Administrar Areas Responsables`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestran los responsables de cada área de inspección.`},
                {   tipo:`label`,   texto:`- En la tabla se muestra el área y si está activa o no.`},
                {   tipo:`label`,   texto:`- En la columna Responsables, al pulsar en el botón de un área, se abrirá una ventana en donde se podrar agregar, editar o eliminar los usuarios responsables de ese área`},
                {   tipo:`label`,   texto:`- En la columna Editar, al pulsar el botón de un área, se abrirá una ventana con los campos de ese área para poder modificarlos (el nombre y si está activo o no). Al finalizar la edición, se debe pulsar en "Actualizar"`},
            ];
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarDatos(){
            //this.mostrarLoading('Cargando Datos...');
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}pac_area_responsable`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data;
                // Event.$emit('actualizar_lista',this.lista);
                // Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones)
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },

        async cargar(query){
            await this.axios.get(`${this.base_url}pac_area_responsable${query}`,this.headers).then((res)=>{
                this.lista = res.data.data.data;
                this.actualizarTablaPaginada({columnas:this.columnas,lista:this.lista,total_paginas:res.data.data.last_page});
            }).catch((e)=>{
                console.log(e);
            })
        },

        async cargarDatos(){
            //this.mostrarLoading('Cargando Datos...');
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}jumbos`;
            await this.axios.get(url,this.headers).then(async (response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data;
                await this.lista.forEach(jumbo => {
                    this.proviene_de.push({id:jumbo.id,texto:`(Lote ${jumbo.lote.nombre_lote}) N°${jumbo.nro_jumbo}`})
                });
                this.inputs[0].opciones = this.proviene_de;
                Event.$emit('actualizar_lista',this.lista);
                Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones);
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                this.$emit('setear_tabla',this.cabeceras_paginada,this.lista);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            })
        },
        crear(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Crear Area Responsable';
            this.configuracion_modal.boton_submit = 'Crear';
            this.configuracion_modal.ruta = 'pac_area_responsable';
            this.configuracion_modal.tipo_peticion = 'POST';
            this.inputs[1].valor = 1;
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async editar($event){
            console.log('editando',$event);
            //por cada input se realiza el seteo correspondiente del item que se esta editando
            await this.inputs.forEach(input => {
                //recorrido del objeto a editar
                Object.keys($event.item).forEach(key => {
                    let valor = $event.item[key];
                    if(input.key == key){
                        input.valor = valor;
                    }
                });
            });

            console.log('inputs con datos a editar',this.inputs);
            this.configuracion_modal.titulo_modal = 'Editar Area Responsable';
            this.configuracion_modal.boton_submit = 'Actualizar';
            this.configuracion_modal.ruta = `pac_area_responsable/${$event.item.id}`;
            this.configuracion_modal.tipo_peticion = 'PUT';
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },

        async cargar_responsables($event){
            this.item_actual = $event.item;
            await this.axios.get(`${this.base_url}pac_area_responsable/usuarios/${$event.item.id}`,this.headers).then((res)=>{
                this.usuarios = res.data.data.usuarios;
                this.responsables_ids = res.data.data.responsables_ids;
                this.dialog = true;
                console.log(res.data);
            }).catch((e)=>{
                console.log(e);
            });
        },

        async guardar_responsables(){
            let body = {
                responsables_ids:this.responsables_ids,
                pac_areas_responsables_id:this.item_actual.id
            }
            await this.axios.post(`${this.base_url}pac_area_responsable/guardar_usuarios`,body,this.headers).then((res)=>{
                console.log(res.data.data);
                this.dialog = false;
            }).catch((e)=>{
                console.log(e);
            });
        },

        ...mapMutations(['mostrarLoading','ocultarLoading','actualizarTablaPaginada'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        'modal':ModalVue,
        'tabla-paginada':TablaPaginada,
        'modal-ayuda': ModalAyudas,
    }
}
</script>